import {Avatar} from "@radix-ui/themes";
import FontAwesome from "../../utilities/FontAwesome";

export function ChatAvatar(props: {
    branding: {
        type: "image" | "fontawesome" | "text",
        alt?: string,
        value: string,
    }
}) {
    if (props.branding.type === "image") {
        return <Avatar src={props.branding.value} alt={props.branding.alt} radius={"full"} color={"gray"} fallback={""} />
    } else if (props.branding.type === "fontawesome") {
        return <Avatar fallback={<FontAwesome name={props.branding.value} />} radius={"full"} color={"gray"} />
    } else if (props.branding.type === "text") {
        return <Avatar fallback={props.branding.value} radius={"full"} color={"gray"} />
    } else {
        return <Avatar fallback={<FontAwesome name={"fa-user"} prefix={"fas"} />} radius={"full"} color={"gray"} />
    }
}